import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSitesState } from '../../redux/slices/sitesSlice';
import { selectContactsState } from '../../redux/slices/contactsSlice';
import SitesTable from './SitesTable';
import SiteActionCard from './SitesActionCard';
import ContactCard from './ContactsCard';
import ContactsCard from './ContactsCard';
import SitesListMobile from './SitesListMobile';
import sortSites from '../../utils/sortSites';
import LoadingSpinner from '../../components/LoadingSpinner';
import InfoText from '../../components/InfoText';

import { Paper, Typography, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useMainPageStyles } from '../../styles/muiStyles';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { fetchAllConcentrateurs, selectConcentrateurById, selectConcentrateursBySiteId, selectConcentrateursBySiteSn, selectConcentrateursState } from '../../redux/slices/concentrateursSlice';
import { AppThunk, RootState } from '../../redux/store';
import concentrateurs from '../../services/concentrateurs';
import { SiteState } from '../../redux/types';
import filterSites from '../../utils/filterSites';
import { selectEquipementsState } from '../../redux/slices/equipementsSlice';

const SitesPage = () => {
  const classes = useMainPageStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const { sites, fetchStatus, fetchError, sortBy, filterBy } = useSelector(
    selectSitesState
  );
  const { contacts } = useSelector(
    selectContactsState
  );
  const { concentrateurs } = useSelector(
    selectConcentrateursState
  );
  //sites.filter((s) => Number(s.sn_site) === 100105).map((g) => console.log("100105 date_end/id: "+g.date_end+" / "+g.id))

//  console.log("SITES: " + sites)
//  console.log("Contacts: "+ (contacts.map((c) => c.nom)))
/*  const { concentrateurs } = useSelector(
    selectConcentrateursState
  );*/
  //const siteId = "10";
  /*const { [siteId]: concentrateurs } = useSelector(
    selectConcentrateursState
  );*/
/*  useEffect(() => {
    if (!concentrateurs) {
      dispatch(fetchAllConcentrateurs());
    //  dispatch(selectContactsBySiteId(siteId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);*/
  const [filterValue, setFilterValue] = useState('');
  let endeds: string[] = []
  sites.map((s) => String(s.date_end).length > 4 ? endeds.push(s.sn_site) : null )
  //  const filteredSortedSites = sites;
/*  let theSites: SiteState[] = []
  if(filterValue === 'all' || filterValue === ''){ theSites = sites }
  if(filterValue === 'closed' ){ theSites = sites.map((s) => { return sites.filter((g) => Number(g.sn_site) === Number(s.sn_site) && sites.filter((k)=>Number(g.sn_site) === Number(k.sn_site)).some((h)=> h.date_end !== null))?.sort((a: SiteState, b: SiteState) => Number(a.id) + Number(b.id)).slice(0)[0]}) }
  if(filterValue === 'running' ){ 
    sites.map((s) => { 
      if(sites.filter((g) => Number(g.sn_site) === Number(s.sn_site)).some((c) => String(c.date_end).length !== 4)) {
        theSites.push(sites.filter((g) => Number(g.sn_site) === Number(s.sn_site))
        .filter((c) => String(c.date_end).length !== 4)
        .sort((a: SiteState, b: SiteState) => Number(a.id) - Number(b.id)).slice(0)[0])
      }
    })
  }*/
/*  if(filterValue === 'running' ){ 
    theSites = sites.map((s) => { return sites.filter((g) => Number(g.sn_site) === Number(s.sn_site) 
      && !sites.filter((k)=>Number(g.sn_site) === Number(k.sn_site))
      .some((h)=> h.date_end !== null))?.sort((a: SiteState, b: SiteState) => Number(a.id) + Number(b.id)).slice(0)[0]}) }*/
  const filteredSortedContacts = contacts;
  const filteredSortedConcentrateurs = concentrateurs;
  const filteredSortedSites = 
    sites &&
  //  theSites &&
      sortSites(
      sites.filter((s) =>
    //  theSites.filter((s) =>
        (//p.name.toLowerCase().includes(filterValue.toLowerCase())
        String(s.sn_site).toLowerCase().includes(filterValue.toLowerCase()) ||
        s.contacts[0]?.nom.toLowerCase().includes(filterValue.toLowerCase()) ||
        String(s.concentrateur[0]?.hardSn).includes(filterValue.toLowerCase()) /*||
        s.concentrateur.map((c) => String(c.modules).toLowerCase().includes(filterValue.toLowerCase()))*/
//        s.concentrateur.map((c) => String(c.modules.map((m) => String(m).toLowerCase().includes(filterValue.toLowerCase()))))
        ) && filterSites(s, endeds,/*theSites),*/ filterBy)
      ),
      sortBy
  );
/*
  const filterSitesConc = (sites: SiteState[]) => {
    sites.map((s) =>
      s.concentrateur.length > 1 ? 
        s.concentrateur.map((c) =>
          console.log(c.hardSn)
        ) &&
        s.concentrateur.map((c) =>
        console.log(c.date_start)
        ) &&
        s.concentrateur.map((c) =>
        console.log(c.date_start)
        )
      : null
    )
    console.log(sites.length)
  }
  filterSitesConc(sites);
*/
  const sitesDataToDisplay = () => {
    if (fetchStatus === 'loading') {
      return (
        <LoadingSpinner
          marginTop={isMobile ? '4em' : '9em'}
          size={isMobile ? 60 : 80}
        />
      );
    } else if (fetchStatus === 'succeeded' && sites.length === 0) {
      return (
        <InfoText
          text="No Sites added yet."
          variant={isMobile ? 'h6' : 'h5'}
        />
      );
    } else if (fetchStatus === 'failed' && fetchError) {
      return (
        <InfoText
          text={`Error: ${fetchError}`}
          variant={isMobile ? 'h6' : 'h5'}
        />
      );
    } else if (
      fetchStatus === 'succeeded' &&
      sites.length !== 0 &&
      filteredSortedSites?.length === 0
    ) {
      return (
        <InfoText text="No matches found." variant={isMobile ? 'h6' : 'h5'} />
      );
    } else {
      return (
        <div className={classes.sitesListTable}>
          {!isMobile ? (
            <SitesTable endeds={endeds} sites={filteredSortedSites} contacts={filteredSortedContacts} concentrateurs={concentrateurs}/*concentrateurs={siteId,filteredSortedConcentrateurs}*/ />
          ) : (
            <SitesListMobile sites={filteredSortedSites} contacts={filteredSortedContacts} /*concentrateurs={filteredSortedConcentrateurs}*/ />
          )}
        </div>
      );
    }
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.headerPaper}>
        <AssignmentIcon
          fontSize="large"
          color="primary"
          className={classes.headerIcon}
        />
        <div>
          <Typography variant={isMobile ? 'h6' : 'h5'} color="secondary">
            Sites de mesures Panel Elecdom
          </Typography>
          <Typography
            variant={isMobile ? 'caption' : 'subtitle1'}
            color="secondary"
          >
            Accueil : liste de tous les logements. Pour accéder aux appareils du logement, cliquez sur le numéro du logement, puis "équipements". 
            Utilisez le menu déroulant pour trier l'ordre des sites, et éventuellement la "recherche" pour entrer un numéro (site / concentrateur) ou un nom (d'occupant).
          </Typography>
        </div>
      </Paper>
      <Paper className={classes.sitesPaper}>
        <SiteActionCard
          filterValue={filterValue}
          setFilterValue={setFilterValue}
          isMobile={isMobile}
        />
        {sitesDataToDisplay()}
      </Paper>
    </div>
  );
};

export default SitesPage;
